

















































































import { Component, Vue, Prop } from 'vue-property-decorator';
import { sortBy } from '@/utils/utils';
import { GQL_paycheckForm_paycheck_ameldings, GQL_paycheckForm_paycheck_ameldings_ameldingToReplace } from '@/queries/__generated__/paycheckForm';

@Component
export default class PaycheckAltinnLog extends Vue {
  @Prop({ type: Array, required: true }) private ameldings!: GQL_paycheckForm_paycheck_ameldings[];
  private highlightedId: number | null = null;

  private get altinnHistory() {
    const interestingReports = this.ameldings
      .filter(report => report.humanStatus !== 'FAILED_SENDING')
      .filter(report => report.humanStatus !== 'SOMETHING_WRONG')
      .filter(report => report.humanStatus !== 'REJECTED');

    if (interestingReports.length < 1) return [];

    return sortBy(interestingReports, report => {
      const submission = report.altinnSubmission || report.altinn3Submission!;

      return [ [ submission.sentAt.valueOf(), 'desc' ], [ report.id, 'desc' ] ];
    });
  }

  private get currentStatus(): string {
    const report = this.altinnHistory[0];
    let status = report.humanStatus;

    if (report.cancellation) {
      // the paycheck is cancelled if the report was successful and a cancellation
      status = this.$t(`Paycheck.AltinnHistory.cancelled`) as string;
    } else {
      status = this.$t(`Amelding.HumanStatuses.${status}`) as string;
    }

    const submission = report.altinnSubmission || report.altinn3Submission!;
    const sentAt = submission.sentAt.format('lll');

    return `${status} (${sentAt})`;
  }

  private highlightReport(id: number): void {
    this.highlightedId = id;
  }

  private hasAmeldingToReplace(report: GQL_paycheckForm_paycheck_ameldings) {
    if (report.ameldingToReplace) return true;
    return false;
  }

  private replacementVerbFor(report: GQL_paycheckForm_paycheck_ameldings) {
    const status = this.statusFor(report);
    let verb;

    if (report.cancellation) {
      verb = this.$t('Paycheck.AltinnHistory.cancels') as string;
    } else {
      verb = this.$t(`Paycheck.AltinnHistory.replaces`) as string;
    }

    return `(${status}) ${verb}`;
  }

  private statusFor(report: GQL_paycheckForm_paycheck_ameldings) {
    return this.$t(`Amelding.HumanStatuses.${report.humanStatus}`) as string;
  }

  private referenceFor(replacee: GQL_paycheckForm_paycheck_ameldings_ameldingToReplace) {
    return replacee.ameldingReference || this.$t('Paycheck.AltinnHistory.unknownReport');
  }

  private processedAt(report: GQL_paycheckForm_paycheck_ameldings) {
    return report.altinnSubmission?.processedAt || report.altinn3Submission?.sentAt;
  }
}
